import { Modal } from "antd";

interface ImagePreviewModalProps {
  url: string | null;
  close: () => void;
}

const ImagePreviewModal = ({ url, close }: ImagePreviewModalProps) => {
  return (
    <Modal
      open={!!url}
      onCancel={close}
      onOk={close}
      title="이미지 확대"
      footer={null}
      width={800}
    >
      <img src={url ?? ""} alt="preview" style={{ width: "100%" }} />
    </Modal>
  );
};

export default ImagePreviewModal;
